import React, { SVGProps } from 'react';

const VerificationIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 13 15"
			fill="none"
			{...props}
		>
			<path
				d="M12.8882 3.90633C12.8704 3.51346 12.8704 3.13845 12.8704 2.76345C12.8704 2.45987 12.6382 2.22772 12.3347 2.22772C10.1025 2.22772 8.40601 1.58485 6.99527 0.209824C6.78098 0.0133919 6.45954 0.0133919 6.24525 0.209824C4.83451 1.58485 3.13805 2.22772 0.905859 2.22772C0.602281 2.22772 0.370134 2.45987 0.370134 2.76345C0.370134 3.13845 0.370134 3.51346 0.352276 3.90633C0.280846 7.6564 0.173701 12.7994 6.44168 14.9601L6.62026 14.9958L6.79883 14.9601C13.049 12.7994 12.9597 7.67426 12.8882 3.90633ZM6.19168 9.10286C6.08453 9.19215 5.95953 9.24572 5.81667 9.24572H5.79881C5.65595 9.24572 5.51309 9.17429 5.42381 9.06714L3.76306 7.22782L4.56665 6.51352L5.87024 7.95998L8.76316 5.20992L9.49532 5.99565L6.19168 9.10286Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default VerificationIcon;
